import Vue from 'vue';
import _ from 'lodash';
import mixins from 'vue-typed-mixins';

import StudyMixin from '@/user/mixins/StudyMixin';
import ReplyView from '@/user/pages/authorized/study/japanese/work/JapaneseReplyView';


type State = {
  replys: ReplyView[];  // 答案表示欄
  focusReplyViewIndex: number;  // フォーカスReplyViewインデックス
};

const state = Vue.observable<State>({
  replys: [],
  focusReplyViewIndex: -1,
});




export default mixins(StudyMixin).extend({

  name: 'StudyJapaneseMixin',

  computed: {
    replys(): ReplyView[] {
      return state.replys;
    },

    hasEmptyReplys(): boolean {
      for (const reply of state.replys) {
        if (reply.getText().length === 0) return true;
      }
      return false;
    },

    prejudgeReplys(): boolean {
      if (state.replys.length === 0) return false;
      const reply = state.replys[0];
      return reply.getText() === reply.getRight();
    },

    focusReplyViewIndex(): number {
      return state.focusReplyViewIndex;
    },
  },

  methods: {
    refreshReplys(length: number = 0): void {
      state.replys = new Array(length);
    },

    setFocus(index: number): void {
      for (const reply of this.replys) reply.setFocusFlag(false);
      state.focusReplyViewIndex = index;
      this.replys[index].setFocusFlag(true);
    },
  }

});
